<template>
  <div>
    <a-modal v-model="visible" :width="1040" title="关联任务" @ok="handleOk" @cancel="close">
      <a-row :gutter="12">
        <a-col :span="5">
          <a-card size="small" title="选择迭代" style="width: 100%; margin-top: 8px">
            <a-skeleton :loading="versionLoading">
              <div v-for="(version, index) in versionData" :key="index">
                <div :class="`${version.id === currentVersion ? 'version-item version-item_active' : 'version-item'}`" @click="onVersion(version.id)">
                  <span class="version-item_name">{{ version.title }} </span>
                </div>
              </div>
            </a-skeleton>
          </a-card>
        </a-col>
        <a-col :span="19">
          <a-input-search v-model="searchKeyword" placeholder="ID或标题搜索" class="requirement_search" allow-clear enter-button @search="onSearch" />
          <a-table :loading="loading" :pagination="pagination" size="small" :columns="columns" row-key="id" :row-selection="rowSelection" :data-source="taskData" @change="handleTableChange">
            <span slot="customTitle" slot-scope="text, record">
              <a-tooltip placement="top" :title="record.name">
                <a class="custom-link" :href="link(record)" target="_blank">{{ record.name }}</a>
              </a-tooltip>
            </span>
            <span slot="status" slot-scope="text, record">
              <a-badge :status="taskStatus[record.status].status" :color="taskStatus[record.status].color" :text="taskStatus[record.status].label" />
            </span>
          </a-table>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { taskList } from '@/api/project/task';
import { taskStatus } from '@/utils/dictionary';
import { versionList } from '@/api/project/version';
import { reviewBindObject } from '@/api/project/review';

const columns = [
  {
    title: 'ID',
    width: 100,
    customRender: (_, text) => {
      return `TS-${text.id}`;
    }
  },
  {
    title: '标题',
    ellipsis: true,
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '状态',
    width: 140,
    scopedSlots: { customRender: 'status' }
  }
];

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    taskList: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      columns,
      taskStatus,
      loading: false,
      visible: false,
      tasks: {},
      taskData: [],
      selected: [],
      reviewId: null,
      selectedRowKeys: [],
      versionLoading: false,
      currentVersion: null,
      versionData: [],
      searchKeyword: '',
      projectId: parseInt(this.$route.params.project_id) || null,
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      }
    };
  },
  computed: {
    relationTasks() {
      return this.selected.map(key => {
        return this.tasks[key];
      });
    },

    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:project:task:detail',
          query: { taskId: record.id }
        }).href;
      };
    },

    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange
      };
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.selected = newVal;
      },
      immediate: true
    },
    selected() {
      this.$emit('change', this.selected);
    },
    taskList: {
      handler(newVal) {
        this.tasks = newVal;
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 点击打开
     */
    onOpen(reviewId) {
      this.reviewId = reviewId;
      // 打开模态框
      this.visible = true;
      // 获取版本列表
      this.getVersionList();
      // 获取任务列表，默认获取全部任务
      this.getTaskList();
    },

    /**
     * 获取版本列表
     */
    getVersionList() {
      this.versionLoading = true;
      versionList({ status: [0], project_id: this.projectId })
        .then(res => {
          this.versionData = res.data.list;
          if (this.currentVersion === null) {
            this.currentVersion = this.versionData[0].id;
          }
          this.versionLoading = false;
          this.getTaskList();
        })
        .catch(() => {
          this.versionLoading = false;
        });
    },

    /**
     * 点击版本
     * @param {*} version_id
     */
    onVersion(version_id) {
      this.currentVersion = version_id;
      this.getTaskList();
    },

    /**
     * 获取任务列表
     */
    getTaskList() {
      this.loading = true;
      taskList({
        project_id: this.projectId,
        keyword: this.searchKeyword,
        version: this.currentVersion,
        status: [3],
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.taskData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 表格分页操作
     * @param {*} pagination
     * @param {*} _
     * @param {*} sorter
     */
    handleTableChange(pagination, _, sorter) {
      this.pagination = pagination;
      this.getTaskList();
    },

    /**
     * 点击搜索
     */
    onSearch() {
      this.pagination.current = 1;
      this.getTaskList();
    },

    // 点击选择任务
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      selectedRows.forEach(item => {
        this.$set(this.tasks, item.id, { id: item.id, key: item.key, name: item.name, status: item.status });
      });
    },

    /**
     * 点击确定
     */
    handleOk() {
      this.selected = [...this.selectedRowKeys];
      reviewBindObject({ review_id: this.reviewId, object_ids: this.selected, object_type: 3 })
        .then(() => {
          this.visible = false;
          this.$message.success('关联成功');
          this.close();
        })
        .catch(() => {
          this.storySelectorVisible = false;
        });
    },

    /**
     * 点击任务标题跳转到任务详情
     * @param {*} record
     */
    onDetail(record) {
      this.$router.push({
        name: 'page:project:task:detail',
        query: {
          taskId: record.id
        }
      });
    },

    /**
     * 关闭模态框
     */
    close() {
      this.visible = false;
      this.selectedRowKeys = [];
      this.$emit('close');
    }
  }
};
</script>
<style lang="less" scoped>
.search-button {
  width: 100%;
}

.requirement_search {
  margin: 8px 0;
}

/deep/.ant-modal-body {
  padding: 12px;
}

/deep/.ant-card-body {
  padding: 8px;
  height: 470px;
  overflow: auto;
}

.version-item {
  height: 36px;
  line-height: 36px;
  cursor: pointer;
  padding: 0 8px;
  margin: 2px -8px;
  display: -webkit-box;
  /**对象作为伸缩盒子模型展示**/
  -webkit-box-orient: vertical;
  /**设置或检索伸缩盒子对象的子元素的排列方式**/
  -webkit-line-clamp: 1;
  /**显示的行数**/
  overflow: hidden;
  /**隐藏超出的内容**/
}

.version-item:hover,
.version-item_active {
  background-color: #e6f7ff;
  color: #1890ff;
}

.version-item_more {
  float: right;
  font-weight: bold;
}
</style>
